module.exports = __webpack_public_path__ + "media/images/eftpos-f9fddbf8ba1401bef67974de9e97dc11.png";